import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as utils from "../../../components/utils.js";

const AI_Editor = ({ node, files, schemas, onChange, parent }) => {
    const { t } = useTranslation();
    const [item, setItem] = useState(node);

    const _notifyChange = () => {
        if (onChange) {
            onChange(item);
        }
    }

    useEffect(() => {
        console.log(item);
        window.$("#ai_editor_files_selection").select2({  dropdownParent: window.$(`#${parent}`)});
        window.$("#ai_editor_files_selection").off("change");
        window.$("#ai_editor_files_selection").on("change", (e) => {
            const _selected = window.$("#ai_editor_files_selection").find(":selected").toArray();
            item.files = [];
            for (var s of _selected) {
                s = window.$(s);
                item.files.push(files.find(x => x.Id == s.attr("value")));
            }
            setItem(JSON.parse(JSON.stringify(item)));
        });

        window.$("#ai_expression_output").select2({  dropdownParent: window.$(`#${parent}`)});
        window.$("#ai_expression_output").off("change");
        window.$("#ai_expression_output").on("change", (e) => {
            item.schema = e.target.value ? e.target.value : null;
            setItem(JSON.parse(JSON.stringify(item)));
        });
    }, [item]);

    return (
        <div>
            <div class="form-group">
                <label for="ai_editor_name">Name</label>
                                        <input type="text" className="form-control" id="ai_editor_name" aria-describedby="ai_editor_name_help" placeholder={t('enterTheName', { ns: 'labels' })}
                    value={item.name} onChange={(e) => {
                        item.name = e.target.value;
                        setItem(utils.clone(item));
                        _notifyChange();
                    }}
                />
                <div class="form-text" >The name used for flows and macros for output data will be: <strong>{utils.code_name(item.name)}</strong></div>
            </div>
            <hr></hr>
            <div class="form-group">
                <label for="ai_editor_files_selection">Additional files to use</label>
                <select id="ai_editor_files_selection" multiple>
                    {files.map((f) => {
                        return (<option value={f.Id} selected={item.files?.some(x => x.Id == f.Id) ? true : null}>{f.Name}</option>);
                    })}
                </select>
            </div>
            <br></br>
            <div class="form-group">
                <label for="ai_query_editor">AI statement</label>
                <textarea id="ai_query_editor" rows={5} className="form-control" value={item.query} onChange={(e) => {
                    item.query = e.target.value;
                    setItem(utils.clone(item));
                    _notifyChange();
                }}></textarea>
            </div>
            <br></br>
            <div class="form-group">
                <label for="ai_expression_output">Apply an output schema</label>
                <select id="ai_expression_output" value={item.schema} onChange={(e) => {
                    item.schema = e.target.value ? e.target.value : null;
                }}>
                    {
                        [(<option value="">-</option>)]
                            .concat(
                                schemas.map((f) => {
                                    return (<option value={f.Id}>{f.name}</option>);
                                }))}
                </select>
            </div>
        </div>);
}

export { AI_Editor }